import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import HeaderBack from 'components/components/account/components/HeaderBack';
import {
  setReservationToEdit,
  fetchPriceList,
} from 'components/actions/serviceActions';
import withRouter from 'components/components/common/withRouter';
import ReservationSummary from './componentsReservationEdit/ReservationSummary';
import ReservationEdit from './componentsReservationEdit/ReservationEdit';
import ReservationEditPassengers from './componentsReservationEdit/ReservationEditPassengers';
import SecureLoadingContent from 'components/components/common/SecureLoadingContent';
import ReservationEditMap from './componentsReservationEdit/ReservationEditMap';
import resizer from 'components/common/Resizer';
import { scrollTo } from 'components/helpers/scrollToElement';

class DashboardEdit extends Component {

  state = {
    addressMode: false,
    passengerMode: false,
    editMode: false,
  }

  componentDidMount() {
    this.props.fetchPriceList();
  }

  setAddressMode = (e) => {
    e.preventDefault();
    this.setState({
      addressMode: true,
      passengerMode: false,
      editMode: true
    }, () => {
      scrollTo({
        elementId: 'sectionMap',
        secondContainerSelector: '#editHolder',
        width: this.props.windowWidth,
        manuallOffset: -70
      });
    });
  }

  setPassengerMode = (e) => {
    e.preventDefault();
    this.setState({
      addressMode: false,
      passengerMode: true,
      editMode: true
    }, () => {
      scrollTo({
        elementId: 'sectionPassengers',
        secondContainerSelector: '#editHolder',
        width: this.props.windowWidth,
      });
    });
  }

  turnOffEditMode = (e) => {
    e.preventDefault();
    this.setState({
      addressMode: false,
      passengerMode: false,
      editMode: false
    });
  }

  callbackLoadedData = (data) => {
    this.props.setReservationToEdit(data);
  }

  render() {
    const { editMode, addressMode, passengerMode } = this.state;
    const isMobile = this.props.windowHeight <= 920;
    const isMobileW = this.props.windowWidth < 640;
    var reservationId = this.props.params.id;
    return (
      <SecureLoadingContent
        callback={this.callbackLoadedData}
        path={"/pwa/reservation/edit/" + reservationId}
        softLoading
      >
        <div id="editHolder" className={classNames(
          'content',
          'content--bg-none',
          { 'content--height-auto': isMobileW }
        )}
          style={{ margin: 0 }}>
          {/******** headers  ********/}
          {!editMode &&
            <HeaderBack
              className="header-back--dashboard"
              link="routes.url.dashboard"
              name="content.layout.sidebarAndHeader.dashboard"
              title="content.layout.sidebarAndHeader.backToDashboardTitle"
              locale={this.props.locale}
            />
          }
          {editMode &&
            <HeaderBack
              className="header-back--dashboard header-back--text"
              link={{ url: 'routes.url.dashboardEdit', params: { id: reservationId } }}
              title="content.layout.sidebarAndHeader.backToEditTitle"
              onClick={this.turnOffEditMode}
              locale={this.props.locale}
            />
          }
          {/******** end headers  ********/}

          <div className={classNames(
            'grid-layout',
            'grid-layout--vh',
            { 'grid-layout--edit-active': editMode }
          )} style={{ padding: 0 }}>
            <ReservationSummary editMode={editMode} locale={this.props.locale} />
            <ReservationEdit
              addressMode={addressMode}
              passengerMode={passengerMode}
              setAddressMode={this.setAddressMode}
              setPassengerMode={this.setPassengerMode}
              locale={this.props.locale}
            />
            <div className={classNames(
              'grid-layout__item',
              'grid-layout__item--desc',
              'grid-layout__item--edit-address', {
                'grid-layout__item--edit-address-active': editMode,
                'grid-layout__item--map': addressMode,
                'grid-layout__item--center': passengerMode,
                'grid-layout__item--height-auto': isMobile
              }
            )}>
              {addressMode &&
                <ReservationEditMap />
              }
              {passengerMode &&
                <ReservationEditPassengers locale={this.props.locale} />
              }
            </div>
          </div>
        </div>
      </SecureLoadingContent>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    reservation: state.service.editedReservation,
    reservationUpdate: state.service.paramsForReservationUpdate,
    locale: state.app.locale
  };
};

export default withRouter(
  resizer(
    connect(
      mapStateToProps,
      { setReservationToEdit, fetchPriceList }
    )(DashboardEdit)
  )
);
